import React from "react";
import { WebEventoDocumentoEntidade } from "../../../../entidades";
import config from "./../../../../config.json";

interface IProps {
  documento: WebEventoDocumentoEntidade;
  indexSelecionado: number;
  index: number;
}

export const Item: React.FC<IProps> = ({
  documento,
  indexSelecionado,
  index
}) => {

  return (
    <>
      <div className={`carousel-item ${indexSelecionado === index ? "active" : ""}`} style={{ "width": "600px", "margin": "auto" }}>
        <img className={"d-block w-100"} style={{ "maxHeight": "450px" }} src={documento && `${config.apiUrl}/Evento/BaixarDocumento/${documento.OID_EVENTO_DOCUMENTO}`} alt={documento.TXT_NOME_FISICO} />
      </div>
    </>
  );
}